import { fork, take, put, select, SelectEffect } from 'redux-saga/effects'

import getConstants from '../../../constants'

import request from 'services/Request'

import * as actionTypes from '../actionTypes'
import * as storeActions from '../actions'
import * as locationSelectors from '../../Location/selectors'
import * as locationActions from '../../Location/actions'
import * as api from '../api'
import * as selectors from '../selectors'

const CONSTANTS = getConstants()

function* getArgs(): Generator<SelectEffect, api.GetAllStoreListProps, any> {
  const limit = yield select(locationSelectors.limit)
  const areaCode = yield select(selectors.areaCode)

  const args: api.GetAllStoreListProps = {
    country: CONSTANTS.COUNTRY,
    areaCode,
    limit,
  }

  return args
}

export function* getAllStoresListWorker(): Generator {
  yield put(storeActions.clearAll(CONSTANTS.IS_EU))
  yield put(locationActions.geoCleared())
  const args = yield getArgs()

  yield request(
    actionTypes.SEARCH_ALL_STORES_REQUESTED,
    api.getAllStoreList,
    args,
  )
}

export function* getAllStoresSaga() {
  while (true) {
    yield take(actionTypes.SEARCH_ALL_STORES_REQUESTED)
    yield fork(getAllStoresListWorker)
  }
}

export default getAllStoresSaga
